import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { getDeliveryMethods } from '../../util/fulfillment';
import { Heading } from '../../components';
import css from './ListingPage.module.css';

/** Display offered delivery methods without revealing the pickup location. */
const SectionDeliveryOptions = ({ publicData }) => {
  const methods = getDeliveryMethods(publicData);
  if (!methods.length) return null;
  return (
    <section className={css.sectionText}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="Fulfillment.delivery" />
      </Heading>
      <p><FormattedMessage id="Fulfillment.shippingAvailable" /></p>
    </section>
  );
};

export default SectionDeliveryOptions;
